import { Field } from "formik";
import * as React from "react";

export const TextInput = ({
  label,
  name,
  onKeyUp,
  errors,
  touched,
  type = "text",
  required = false,
}) => {
  return (
    <div>
      <label
        htmlFor={name}
        className={`block text-base font-medium mb-2 ${
          required ? "required-input" : ""
        }`}
      >
        {label}
      </label>
      <Field
        name={name}
        type={type}
        className="border border-primary w-full px-3 py-2 rounded"
        onKeyUp={onKeyUp}
      />
      {errors[name] && touched[name] ? (
        <div className="text-xs text-red-500">{errors[name]}</div>
      ) : null}
    </div>
  );
};
